import React from 'react';
import { Platform } from 'react-native';
import { useTranslation } from 'react-i18next';
import {
  Icon,
  Menu, MenuItem, MenuItemLabel
} from '@gluestack-ui/themed';
import { Linking } from 'react-native';
import { ExternalLink, Trash, Download } from 'lucide-react-native';

// Common viewable file types
const VIEWABLE_TYPES = [
  'image/',
  'text/',
  'application/pdf',
  'video/',
  'audio/'
];

const AttachmentMenu = ({ attachment, onDeleteAttachment, isDeleting, trigger, allowDelete = true }) => {
  const { t } = useTranslation();

  if (!attachment.filename) return null;

  // const isViewable = VIEWABLE_TYPES.some(type =>
  //   attachment.contentType?.startsWith(type)
  // );

  const isViewable = true;

  const handleOpenAttachment = () => {
    if (Platform.OS === 'web') {
      // On web, use an anchor tag to maintain user interaction context
      const link = document.createElement('a');
      link.href = attachment.url;

      // If it's a viewable type, open in new tab
      if (isViewable) {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      } else {
        // For non-viewable types, trigger download
        link.download = attachment.filename;
      }

      link.click();
    } else {
      // On mobile, use system handler
      Linking.openURL(attachment.url);
    }
  };

  return (
    <Menu
      placement="top left"
      // offset={10}
      trigger={trigger}
    >
      <MenuItem
        key="open"
        textValue={isViewable ? "Open in new tab" : "Download"}
        isDisabled={isDeleting}
        onPress={handleOpenAttachment}
      >
        <Icon as={isViewable ? ExternalLink : Download} size="sm" ml="$4" />
        <MenuItemLabel size="sm" ml="$4">
          {isViewable
            ? t('student.task.attachments.menu.open')
            : t('student.task.attachments.menu.download')
          }
        </MenuItemLabel>
      </MenuItem>
      {allowDelete && (
        <MenuItem
          key="delete"
          textValue="Delete"
          isDisabled={isDeleting}
          onPress={onDeleteAttachment}
        >
          <Icon as={Trash} size="sm" ml="$4" />
          <MenuItemLabel size="sm" ml="$4">{t('student.task.attachments.menu.delete')}</MenuItemLabel>
        </MenuItem>
      )}
    </Menu>
  );
};

export default AttachmentMenu;
